import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';
import { PositionListComponent } from './pages/position/position-list/position-list.component';
import { AccountDetailComponent } from './pages/account/account-detail/account-detail.component';
import { AllocationDetailComponent } from './pages/allocation/allocation-detail/allocation-detail.component';
import { AllocationListComponent } from './pages/allocation/allocation-list/allocation-list.component';
import { ViewAllocationsComponent } from './pages/allocation/view-allocations/view-allocations.component';
import { ViewLogListComponent } from './pages/allocation/view-log/view-log-list/view-log-list.component';
import { ViewTodayOrdersComponent } from './pages/allocation/view-today-orders/view-today-orders.component';
import { ProfileComponent } from './pages/profile/profile.component';

export const routes: Routes = [
  {
    path: 'account/account-detail',
    component: AccountDetailComponent,
    canActivate: [authGuardFn],
    data: { title: 'Account Detail' }
  },
  {
    path: 'account/account-detail/:AccountID',
    component: AccountDetailComponent,
    canActivate: [authGuardFn],
    data: { title: 'Account Detail' }
  },
  {
    path: 'allocate/allocation-detail',
    component: AllocationDetailComponent,
    canActivate: [authGuardFn],
    data: { title: 'Allocation Detail' }
  },
  {
    path: 'allocate/allocation-list',
    component: AllocationListComponent,
    canActivate: [authGuardFn],
    data: { title: 'Allocation List' }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [authGuardFn],
    data: { title: 'Profile' }
  },
  {
    path: 'allocate/view-allocations',
    component: ViewAllocationsComponent,
    canActivate: [authGuardFn],
    data: { title: 'View Allocations' }
  },
  {
    path: 'allocate/view-log',
    component: ViewLogListComponent,
    canActivate: [authGuardFn],
    data: { title: 'View Log' }
  },
  {
    path: 'allocate/view-today-orders',
    component: ViewTodayOrdersComponent,
    canActivate: [authGuardFn],
    data: { title: 'View Today\'s Orders' }
  },
  {
    path: 'position',
    component: PositionListComponent,
    canActivate: [authGuardFn],
    data: { title: 'Positions' }
  },
  {
    path: '',
    redirectTo: 'account/account-detail',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'account/account-detail'
  }
];
